import { render, staticRenderFns } from "./ManufacturerDetails.vue?vue&type=template&id=145dfd47&"
import script from "./ManufacturerDetails.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145dfd47')) {
      api.createRecord('145dfd47', component.options)
    } else {
      api.reload('145dfd47', component.options)
    }
    module.hot.accept("./ManufacturerDetails.vue?vue&type=template&id=145dfd47&", function () {
      api.rerender('145dfd47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ManufacturerDetails.vue"
export default component.exports